import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { TimeFrameSelect } from './components/time-frame-select';
import * as SX from './sx';
import type { TimeFrameFilterProps as Props } from './types';

export const TimeFrameFilter = memo(
  ({ className, onChange, error, value, ...filter }: Props) => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={0.5}
        className={classnames('TimeFrameFilter', className)}
        paddingLeft={1}
        paddingBottom={1}
        sx={SX.root}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body4" color="grey.600" fontWeight={500}>
            With in the last
          </Typography>
          <TimeFrameSelect filter={filter} value={value} onChange={onChange} />
          <Typography variant="body4" color="grey.600" fontWeight={500}>
            Months
          </Typography>
        </Box>
        {error && (
          <Typography variant="body5" color="error">
            The Time Frame has not been chosen.
          </Typography>
        )}
      </Box>
    );
  }
);

TimeFrameFilter.displayName = 'TimeFrameFilter';
